import { useMemo } from 'react';
import BarbeariaApp from './components/barbearia/BarbeariaApp';
import BarbeariaPainelLicencas from './components/barbearia/BarbeariaPainelLicencas';
import { isPainelLicencasUrl } from './utils/barbeariaLicenca';

export default function App() {
  const painelLicencas = useMemo(() => isPainelLicencasUrl(), []);

  if (painelLicencas) {
    return (
      <div className="mx-auto min-h-screen max-w-6xl px-4 py-6">
        <BarbeariaPainelLicencas />
      </div>
    );
  }

  return (
    <div className="mx-auto min-h-screen max-w-6xl px-4 py-6">
      <BarbeariaApp />
    </div>
  );
}
